import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';

import lang from '../../lib/language';
import { RootState } from '../../lib/store';
import {
  updateIndividualTransitionToForVerification as updateIndividualTransitionToForVerificationCall,
} from '../../lib/store/crm';
import {
  isAuthEnrollPortalStatusInitial,
  isAuthEnrollPortalStatusPending, isFundPortalEnrollmentStepsCompleted,
  isMyPortalTradeEnrollmentStepsCompleted,
} from '../../lib/store/selectors';
import { isMyPortalTrade } from '../../lib/util/auth/helpers';

import experienceAllCompletedImage from '../../assets/bigImages/experience_all_completed.png';
import { Button } from '../../components';
import { ButtonTypesEnum } from '../../components/Button/Button.types';
import { useIsMobile } from '../../hooks';
import { UI_ROUTES } from '../../util/routes';

import styles from './EnrollAccountActivated.module.scss';

type Props = {}

const EnrollAccountActivated = (props: Props) => {
  const isMobile = useIsMobile();
  const history = useHistory();
  const dispatch = useDispatch();

  const isEnrollPortalStatusInitial:boolean = useSelector((state: RootState) => isAuthEnrollPortalStatusInitial(state));
  const isEnrollPortalStatusPending:boolean = useSelector((state: RootState) => isAuthEnrollPortalStatusPending(state));
  const isMyPortalEnrollCompleted:boolean = useSelector(
    (state: RootState) => isMyPortalTradeEnrollmentStepsCompleted(state.auth.enrollPortalStatus),
  );
  const isFundPortalEnrollCompleted:boolean = useSelector(
    (state: RootState) => isFundPortalEnrollmentStepsCompleted(state),
  );

  if (!isEnrollPortalStatusInitial && !isEnrollPortalStatusPending && !isMyPortalTrade()) {
    if (!isFundPortalEnrollCompleted) {
      history.goBack();
    } else if (isMyPortalEnrollCompleted) {
      history.goBack();
    }
  }

  return (
    <>
      <div className={[styles.textsWrapper, isMobile ? styles.textsWrapperMob : undefined].join(' ')}>
        <div className={styles.imageWrapper}>
          <img
            src={experienceAllCompletedImage}
            className={styles.image}
            alt=""
          />
        </div>
        <p className={styles.caption}>
          {lang.commonOnboardingExperienceTradingProfileComplete()}
        </p>
        <p className={styles.description}>
          {lang.commonOnboardingExperienceItMayTakeADay()}
        </p>
        <p className={styles.line} />
        <Button
          id="closeEnrollment"
          ariaLabel="close enrollment"
          variant={ButtonTypesEnum.Primary}
          onClick={() => {
            dispatch(updateIndividualTransitionToForVerificationCall());
            history.push(UI_ROUTES.overview);
          }}
          className={classNames(styles.submitButton, { [styles.skipButton]: true })}
        >
          {lang.commonContinueButton()}
        </Button>
      </div>
    </>
  );
};

export default EnrollAccountActivated;
